module.exports = __webpack_public_path__ + "static/media/calendar2.11e52313.svg";